import React from 'react'
import styled from '@emotion/styled'
import { Icon } from '@mobi/component-library/Common/V2/Icon'
import { Button } from '@mobi/component-library/Common/V2/Buttons'
import { colors, font, shadow, spacing } from '@mobi/component-library/Theme/Common'
import { SortFeedLabel } from '../../types'

export const SortButtonBar: React.FC<{ onClick(): void; label: SortFeedLabel }> = ({
  onClick,
  label,
}) => (
  <SortFeedButtonWrapperStyled>
    <Button color='tertiary_color' size='xs' onClick={onClick}>
      Sort By:
      <strong>{label}</strong>
      <Icon name='SolidChevronDown' size='1.4rem' />
    </Button>
  </SortFeedButtonWrapperStyled>
)

// ======
// Styles
// ======

const SortFeedButtonWrapperStyled = styled.div({
  height: '5.2rem',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  paddingLeft: '0.2rem',
  color: colors.lavender['700'],
  backgroundColor: colors.white,
  borderBottom: `1px solid ${colors.neutral[100]}`,
  boxShadow: shadow.xs,
  position: 'relative',
  zIndex: 1,

  '> button': {
    gap: spacing.smx2,

    strong: {
      display: 'flex',
      alignItems: 'center',
      fontWeight: font.weight.semibold,
    },
  },
})
